import { MemoCircleCheck } from '../../../assets/icons/MemoCircleCheck';

export type ApplianceCareTermsProps = {
  href: string;
  brand: string;
  alignIcon?: 'center' | 'start';
};

export const ApplianceCareTerms = ({ href, brand }: ApplianceCareTermsProps) => (
  <div className="flex items-start">
    <div className="shrink-0">
      <MemoCircleCheck />
    </div>
    <p className="ml-space-100">
      Limitations and exclusions apply. Please see the complete{' '}
      <a className="text-body-link-strong" href={href} target="_blank" rel="noopener noreferrer">
        {brand} Appliance Care terms and conditions
      </a>{' '}
      for details.
    </p>
  </div>
);
